import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../../assets/img/logo-header.png';
import LeftSideBarItem from "./LeftSideBarItem";
import LeftSideBarParentItem from "./LeftSideBarParentItem";
import { useSelector, useDispatch } from 'react-redux'
import { menuToggle ,activated} from "../../reducer"
import axios from 'axios';
import config from "../../config.js";

const LeftSideBar = () => {
    const state = useSelector((state) =>state)
    const toggle = state.menuToggle.toggle
    const active = state.active.active
   // console.log(active);

    const dispatch = useDispatch()
    let ClientLogo=localStorage.getItem('ClientLogo');
    let SystemModules = JSON.parse(localStorage.getItem('SystemModules'));

    let all = {};

    useEffect(() => {

        if(!JSON.parse(localStorage.getItem("redux_menu_active")) ){
            SystemModules.forEach((MenuItem, index) => {
                defaultActive(MenuItem,all);
            });
            dispatch(activated(all))
        }



    }, [])
    const token = localStorage.getItem('token')
    const [user, setUser ] = useState([]);

    useEffect(() => {

        axios(config.SystemUrl + `Profile/0`, {
            headers: {
                "Accept": "application/json",
                "lang": "en",
                'Authorization' : "Bearer " + token
            }
        })
            .then(result => setUser(result.data.data));
    }, [])
    const defaultActive =(MenuItem,all)=>{

        if (Array.isArray(MenuItem.child)) {
            all[MenuItem.id] =""
            MenuItem.child.forEach((MenuItemNew) => {
                defaultActive(MenuItemNew,all);
            })
        }
    }
    const activeSideBar = (index) => {
        // console.log(index)
        all = {...active};

        if (active[index] == "") {
            all[index] = "hover show"
            dispatch(activated(all))
        } else {
            all[index] = ""
            dispatch(activated(all))
        }
    }
    return (
        <div id="kt_aside" className="aside aside-light aside-hoverable" data-kt-drawer="true"
            data-kt-drawer-name="aside" data-kt-drawer-activate="{default: true, lg: true}"
            data-kt-drawer-overlay="true" data-kt-drawer-width="{default:'200px', '300px': '250px'}"
            data-kt-drawer-direction="start">
            <div className="aside-logo flex-column-auto" id="kt_aside_logo">
                <NavLink className="row small mt-3" to={'/'}>
                    <div className="col-md-6">
                        <img alt="Logo" src={logo} className="logo" />
                    </div>
                    <div className="col-md-6">
                        <img alt="ClientLogo" src={ClientLogo} className="logo" />
                    </div>
                </NavLink>
                <div id="kt_aside_toggle" onClick={()=>dispatch(menuToggle())} className={"btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle " + toggle }>
                    <span className="svg-icon svg-icon-1 rotate-180">
                        <svg xmlns="http://www.w3.org/2000/svg"
                            width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                <polygon points="0 0 24 0 24 24 0 24" />
                                <path
                                    d="M5.29288961,6.70710318 C4.90236532,6.31657888 4.90236532,5.68341391 5.29288961,5.29288961 C5.68341391,4.90236532 6.31657888,4.90236532 6.70710318,5.29288961 L12.7071032,11.2928896 C13.0856821,11.6714686 13.0989277,12.281055 12.7371505,12.675721 L7.23715054,18.675721 C6.86395813,19.08284 6.23139076,19.1103429 5.82427177,18.7371505 C5.41715278,18.3639581 5.38964985,17.7313908 5.76284226,17.3242718 L10.6158586,12.0300721 L5.29288961,6.70710318 Z"
                                    fill="#000000" fillRule="nonzero"
                                    transform="translate(8.999997, 11.999999) scale(-1, 1) translate(-8.999997, -11.999999)" />
                                <path
                                    d="M10.7071009,15.7071068 C10.3165766,16.0976311 9.68341162,16.0976311 9.29288733,15.7071068 C8.90236304,15.3165825 8.90236304,14.6834175 9.29288733,14.2928932 L15.2928873,8.29289322 C15.6714663,7.91431428 16.2810527,7.90106866 16.6757187,8.26284586 L22.6757187,13.7628459 C23.0828377,14.1360383 23.1103407,14.7686056 22.7371482,15.1757246 C22.3639558,15.5828436 21.7313885,15.6103465 21.3242695,15.2371541 L16.0300699,10.3841378 L10.7071009,15.7071068 Z"
                                    fill="#000000" fillRule="nonzero" opacity="0.5"
                                    transform="translate(15.999997, 11.999999) scale(-1, 1) rotate(-270.000000) translate(-15.999997, -11.999999)" />
                            </g>
                        </svg>
                    </span>
                </div>
            </div>
            <div className="aside-menu flex-column-fluid">
                <div className="hover-scroll-overlay-y my-2 py-5 py-lg-8" id="kt_aside_menu_wrapper"
                    data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}"
                    data-kt-scroll-height="auto" data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer"
                    data-kt-scroll-wrappers="#kt_aside_menu" data-kt-scroll-offset="0">
                    <div
                        className="menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500"
                        id="#kt_aside_menu" data-kt-menu="true">
                         {/*<LeftSideBarItem*/}
                         {/*    MenuItem={*/}
                         {/*        {   id:0,*/}
                         {/*            icon:"bi bi-house fs-3",*/}
                         {/*            route:"dashboard",*/}
                         {/*            name_en:"Dashboard"*/}
                         {/*        }*/}
                         {/*    }/>*/}
                        {SystemModules.map(function (MenuItem, MenuItemKey) {
                            if (Array.isArray(MenuItem.child)) {
                                var count = 0 ;
                                return <LeftSideBarParentItem MenuItem={MenuItem} User={user} count={count} activeSideBar={activeSideBar} MenuItemKey={MenuItemKey} active={active} key={MenuItemKey}/>

                            } else {
                                return MenuItem.menu == "show" && <LeftSideBarItem User={user} MenuItem={MenuItem} key={MenuItemKey}/>

                            }

                        })}

                    </div>
                </div>
            </div>
        </div>
    );
}
export default LeftSideBar;
